module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/help-to-buy-8148350502ace5439a4df9b40dce3e5c.png";